<template>
<!--  viewBox="0 0 14 14"-->
  <circle cx="5.99987" cy="5.99987" r="4.99987" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9996 12.9998L9.53305 9.5332L12.9996 12.9998Z" fill="currentColor"/>
  <path d="M12.9996 12.9998L9.53305 9.5332" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</template>